import { synapse } from 'state'
import { BASE_URL } from 'config'

export const validateFetch = async ({ body, validationUrl }) => {
  const url = `${BASE_URL}${validationUrl}`
  return await synapse.fetch(url, { method: 'POST' }, body)
}
